module.exports = __webpack_public_path__ + "img/sol_isol_pain3.bd581b81.png";